/* eslint-disable camelcase */
import classNames from "classnames";
import { useFormContext } from "react-hook-form";

// Components
import InputSearch from "components/atoms/InputSearch";
import LanguageItem from "components/atoms/LanguageItem";

// Constants
import { LanguageType } from "constants/languages";
import { SearchFields } from "constants/variables";

// Hooks
import { useBreakpoint } from "hooks/useBreakpoint";
import useTranslate from "hooks/useTranslate";

import "./styles.sass";

type LanguageSelectFormProps = {
  languages: LanguageType[];
  selectedLanguage: string;
  onChange: (name: string) => void;
};

const LanguageSelectForm = (props: LanguageSelectFormProps) => {
  const { languages, selectedLanguage, onChange } = props;
  const { watch } = useFormContext();
  const { isDesktop } = useBreakpoint();
  const t = useTranslate();
  const searchQuery = watch(SearchFields.LANGUAGE);

  const contentClass = classNames("LanguageSelect__content", {
    LanguageSelect__content_mobile: !isDesktop,
  });

  const optionsClass = classNames("LanguageSelect__content_options", {
    LanguageSelect__content_options_mobile: !isDesktop,
  });

  const languagesClass = classNames("LanguageSelect__content_languages", {
    LanguageSelect__content_languages_mobile: !isDesktop,
  });

  const searchLanguages = searchQuery
    ? languages.filter((lang) =>
        lang.name.toLowerCase().startsWith(searchQuery.toLowerCase()),
      )
    : languages;

  return (
    <div className={contentClass}>
      <div className={optionsClass}>
        <InputSearch
          name={SearchFields.LANGUAGE}
          placeholder={t("placeholder.search")}
          value=""
        />
        <div className={languagesClass}>
          {searchLanguages.map((lang) => (
            <LanguageItem
              key={lang.id}
              language={lang}
              active={selectedLanguage === lang.isoCode}
              onClick={() => onChange(lang.isoCode)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LanguageSelectForm;
